const TeamItems = [
  {
    school: "Aarhus University",
    student1: "Julie Sihm",
    student2: "Rasmus Staal Knudsen",
    student3: "Frederik Sevelsted Pedersen",
    student4: "Laust Lyhne Christensen",
    coach1: "Adam Victor Gordon",
    coach2: "",
  },
  {
    school: "Concordia University",
    student1: "James Hui",
    student2: "Dolby Ly",
    student3: "Jerry Zhu",
    student4: "Axel Gizard",
    coach1: "John Fragos",
    coach2: "",
  },
  {
    school: "Corvinus University of Budapest",
    student1: "Dániel Stephen Kostyal",
    student2: "Peter Zombori",
    student3: "Regina Bunevácz",
    student4: "Botond Várhegyi",
    coach1: "Peter Feher",
    coach2: "Marta Aranyossy",
  },
  {
    school: "HEC Montréal",
    student1: "Laurence Carbonneau",
    student2: "Guillaume Fraticelli",
    student3: "Sandrine Auclair",
    student4: "Jeanne Brabant",
    coach1: "Michel Mainville",
    coach2: "Alina Dulipovici",
  },
  {
    school: "Hong Kong University of Science and Technology",
    student1: "Aayush Prashant Gala",
    student2: "WONG Yeuk Nam Yvonne",
    student3: "Aryan Sethi",
    student4: "Celine Husada",
    coach1: "Prof. Dongwon LEE",
    coach2: "",
  },
  {
    school: "Indiana University",
    student1: "Ellie Socher",
    student2: "Caleb McNeil",
    student3: "Sweta Murthy",
    student4: "Jake Milsaps",
    coach1: "Joel Rubin",
    coach2: "Joshua Dennis",
  },
  {
    school: "Iowa State University",
    student1: "Kelsey Boal",
    student2: "Rachel Grober",
    student3: "Elisa Chau",
    student4: "Emma Meter",
    coach1: "John Burnley",
    coach2: "",
  },
  {
    school: "Ivey Business School",
    student1: "Annie Liu",
    student2: "Nihaal Rana",
    student3: "Robert Di Marco",
    student4: "Samantha Lin",
    coach1: "Jana Seijts",
    coach2: "",
  },
  {
    school: "Maastricht University",
    student1: "Henri Karaski",
    student2: "Jonathan Stormberg",
    student3: "Levi Kroezen",
    student4: "Toni Greiner",
    coach1: "Nick Sutton",
    coach2: "",
  },
  // {
  //   school: "Technical University Munich",
  //   student1: "Maximilian Werner",
  //   student2: "Richard Quaderer Lizarraga",
  //   student3: "Lukas Nolte",
  //   student4: "Stefan Kovacevic",
  //   coach1: "Alexandra Mittermaier",
  //   coach2: "",
  // },
  {
    school: "Universidad Panamericana",
    student1: "Karla Valeria Alatorre Larrañaga",
    student2: "Luis Manuel Castellanos Marroquín",
    student3: "Zaida Paola Velázquez Galván",
    student4: "Ana Sofia Paredes Camberos",
    coach1: "Ana Cristina González de Alba",
    coach2: "Claudio Guillermo Vázquez Beas",
  },
  {
    school: "University of Houston",
    student1: "Mahin Ahsan",
    student2: "Anh Huynh",
    student3: "Sri Pillai",
    student4: "Viet Nguyen",
    coach1: "Richard Skinner",
    coach2: "",
  },
  {
    school: "University of Minnesota",
    student1: "Eileen Chen",
    student2: "Ariel Chau",
    student3: "Madhava Raveendra",
    student4: "Thomas Farrell",
    coach1: "Ken Reily",
    coach2: "Corrie Fiedler",
  },
  {
    school: "University of Toronto",
    student1: "Zimman Yousuf",
    student2: "Yeji Ma",
    student3: "Thomas Speciel",
    student4: "Kush Jindal",
    coach1: "Annabeth Lin",
    coach2: "Linnet Kocheril",
  },
  {
    school: "Wilfrid Laurier University",
    student1: "David McMillan",
    student2: "Arjunn Sivakumar",
    student3: "Abhirup Shah",
    student4: "Wei Pang",
    coach1: "Josephine McMurray",
    coach2: "Matthew Raines",
  },
]

export default TeamItems
